import Backbone from 'backbone';
import { Dialog } from '@bingads-webui/dialog';
import messageTemplate from './template/bulk-delete-lightbox-message.pug';

const i18n = window.globalLegacyI18n.get('@bingads-webui/i18n-amd-loader!campaignui/feature/bulk-action-accounts-grid');

export class MessageView extends Backbone.View {
  initialize({message}) {
    this.message = message;
  }

  render() {
    this.$el.html(messageTemplate({message: this.message}));
    return this;
  }
}

export default class View extends Backbone.View {
  initialize({
    proceedButtonClickCallback,
    accountsCount,
  }) {
    this.proceedButtonClickCallback = proceedButtonClickCallback;
    this.accountsCount = accountsCount;
    let buttons = [{
      text: i18n.getString('BulkAccountDelete_Proceed'),
      name: 'primaryButton',
      class: 'btn btn-primary lightboxPrimary',
      disabled: accountsCount <= 0,
    }, {
      text: i18n.getString('BulkAccountDelete_Goback'),
      name: 'defaultButton',
      class: 'btn btn-default lightboxDefault',
    }];

    this.lightboxDiv = new Dialog({ className: 'bulk-delete-dialog', showCloseButton: false });
    this.lightboxDiv.setContent(new MessageView({message: i18n.getString('BulkAccountDelete_Body')}));
    this.lightboxDiv.setState({
      title: i18n.getString('BulkAccountDelete_Title'),
      buttons,
    });
    this.lightboxDiv.on('clickedButton', (name) => {
      if (name === 'primaryButton') {
        this.proceedButtonClickCallback();
      }
      this.lightboxDiv.remove();
    });
    document.body.appendChild(this.lightboxDiv.el);
  }

  render() {
    this.lightboxDiv.show();
    return this;
  }
}
